/**
 * 公開エントリポイント。
 * IIFE ビルドでは、このモジュールの export 群がグローバルオブジェクト（brand.ts の
 * GLOBAL_NAME）として露出する。公開 API 面は設計書 §クライアント設計・公開 API 面に従う。
 */
import { autoInit } from './core/factory';

export { create, parse } from './core/factory';
export { defaults } from './core/defaults';
export { librarySearch } from './search/library-search';
export type { LibraryBook, LibrarySearchOptions, LibrarySearchHandle } from './search/library-search';
export { userShelf, readingHistory } from './user-data/widgets';
export type { UserListOptions, UserListHandle } from './user-data/widgets';
export type { MarkType, UserItem } from './user-data/store';
export type { Comments, CommentItem, LikeState, PostResult } from './user-data/comments';

export type { Viewer, ViewerState, ViewerStatus } from './core/viewer';
export type {
  ViewerOptions,
  ViewerOptionsInput,
  ReadingDirection,
  ViewMode,
  EngineKind,
  FlipDirection,
  ShareOptions,
  ShareTarget,
  AnalyticsOptions,
} from './core/options';
export type { Viewport } from './core/engine';
export type { PublicEventMap, PublicEventName, EventHandlers, SearchHit } from './core/events';
export type { BookManifest, PageInfo, OutlineNode } from './core/manifest';

autoInit();
